import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { EmailData } from 'client/bundles/types';

const b = cn('email');

interface Props {
    email: EmailData;
}

class Email extends Component<Props> {
    render() {
        const { email } = this.props;

        return (
            <a href={`mailto:${email}`} className={b()}>{email}</a>
        );
    }
}

export default Email;
